import styled from 'styled-components';

import Section from 'Elements/Section';

export const Wrapper = styled(Section)`
    height: 100%;
    width: 100%;
`;
